import React, { useCallback, useState } from 'react';
import CustomizePageContext from './CustomizePageContext';
import { DOMAIN_TYPES } from '../Constants/values';

const CustomizePageProvider = ({ children, pageConfig }) => {
  const languageOptions = pageConfig?.languageOptions;
  const showStepNumbers = pageConfig?.showStepNumbers;
  const countryOptions = pageConfig?.countryOptions;

  const setInitialLanguages = () => {
    const _selectedLanguages = {};

    if (languageOptions) {
      for (const language of Object.values(DOMAIN_TYPES)) {
        if (_selectedLanguages[language] || !languageOptions[language]?.length) {
          continue;
        }

        _selectedLanguages[language] = Object.values(languageOptions[language])[0].value;
      }
    }

    return {
      ...{
        [DOMAIN_TYPES.FRONTEND]: null,
        [DOMAIN_TYPES.BACKEND]: null
      },
      ..._selectedLanguages
    };
  };

  const [selectedLanguage, setSelectedLanguage] = useState(setInitialLanguages);
  const [_languageOptions] = useState(languageOptions);
  const [_countryOptions] = useState(countryOptions);

  const handleSelectLanguage = useCallback(
    (domain, language) => {
      if (!Object.values(DOMAIN_TYPES).includes(domain)) {
        return;
      }
      setSelectedLanguage((state) => ({ ...state, [domain]: language }));
    },
    [setSelectedLanguage]
  );

  return (
    <CustomizePageContext.Provider
      value={{
        showStepNumbers,
        languageOptions: _languageOptions,
        countryOptions: _countryOptions,
        selectedLanguage,
        handleSelectLanguage
      }}
    >
      {children}
    </CustomizePageContext.Provider>
  );
};

export default CustomizePageProvider;
